module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightPage"
  }, [_vm._v("First published in 1934 by Jonathan Cape")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_vm._v("This edition first published in 2004 by Grub Street Publishing, 4 Rainham Close, London SW11 6SS")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_vm._v("Copyright this edition © 2004 Grub Street, London")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_vm._v("Reprinted 2005, 2007, 2008, 2009, 2010")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_vm._v("Copyright text © V. M. Yeates / Guy Yeates")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("British Library Cataloguing in Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage1"
  }, [_vm._v("Yeates, V. M. (Victor M.), 1897–1934")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage3"
  }, [_vm._v("Winged victory")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage3"
  }, [_vm._v("1. World War, 1914-1918—Aerial operations—Fiction")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage3"
  }, [_vm._v("2. War stories")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage3"
  }, [_vm._v("I. Title")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage3"
  }, [_vm._v("823.9′12[F]")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ISBN 978-1-904010-65-4")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("eISBN 978-1-908117-99-1")])]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the copyright owner.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_vm._v("Cover design by Hugh Adams, AB3 Design")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage2"
  }, [_vm._v("Printed and bound in Great Britain by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightPage1"
  }, [_vm._v("MPG Books Ltd, Bodmin, Cornwall")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cb77424","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WingedVictory_copyright.vue
// module id = 60
// module chunks = 0